import { FadeLoader } from "react-spinners";

const LoadingDots = () => {
  return (
    <div className="flex scale-x-[-1] transform items-center justify-center">
      <FadeLoader
        color="#FFFFFF"
        cssOverride={{}}
        loading
        margin={2}
        radius={10}
        width={10}
        height={10}
      />
    </div>
  );
};

export default LoadingDots;
